<template>
  <v-col cols="12" md="6">
    <v-card class="main-card">
      <div class="card-title">
        <v-card-title style="word-break: keep-all">
          Proactividad
        </v-card-title>
        <v-icon x-large
                color="#2DCE98"
                class="email-icon">
          {{ 'mdi-email' }}
        </v-icon>

      </div>
      <v-card-text class="text-value">
        <div class="px-4">
          <v-row>
            <span class="pb-2">Total de mensajes enviados</span>
            <v-spacer/>
            <span class="font-weight-bold">{{ results.all && results.all[0] ? results.all[0].all : 0 }}</span>
          </v-row>

          <v-row>
            <span class="pb-2">Personas únicas</span>
            <v-spacer/>
            <span class="font-weight-bold">{{ results.uniques && results.uniques[0] ? results.uniques[0].uniques : 0 }}</span>
          </v-row>

          <v-row>
            <span>Mensajes respondidos</span>
            <v-spacer/>
            <span class="font-weight-bold"> {{ results.attended && results.attended[0] ? results.attended[0].attended : 0 }}</span>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters } from 'vuex'
import conversationsService from '@/services/conversationsService.js'

export default {
  created () {
    this.getProactivity()
  },
  computed: {
    ...mapGetters(['datesRange'])
  },
  data () {
    return {
      results: {}
    }
  },
  methods: {
    async getProactivity () {
      const appId = this.$store.getters.appUuid
      const companyId = this.$store.getters.companyUuid
      const token = this.$store.getters.token
      this.results = await conversationsService.getProactivity(token, companyId, appId, this.datesRange)
    }
  },
  watch: {
    datesRange: {
      handler () {
        this.getProactivity()
      }
    }
  }
}
</script>

<style scoped>
.card-title {
  display: inline-flex;
  width: 100%;
  place-content: space-between;
}
.email-icon {
  font-size: 70px !important;
  margin-right: 3%;
}
.main-card {
  border-radius: 5px !important;
  width: 100% !important;
  height: 100%;
}
.main-card__value {
  font-size: 34px;
}
.percentage {
  position: absolute;
  bottom: 0;
  margin-bottom: 3%;
}
.text-value {
  font-size: 20px;
  margin-top: 10%
}
.value {
  display: flex;
  justify-content: center;
  margin-bottom: 18%;
}
</style>
